import { isValidDate, toIso8601DateTime } from "@/shared/lib/datetime";
import { Box, type SxProps, type Theme, Typography } from "@mui/material";
import { BaseDatePicker } from "../base-date-picker";
import { BaseFormLabel } from "../base-form-label";

export const DateRangePicker = ({
  label,
  startDate,
  endDate,
  onStartDateChange = () => {},
  onEndDateChange = () => {},
  sx,
}: {
  label: string;
  sx?: SxProps<Theme>;
  startDate?: string | null;
  endDate?: string | null;
  onStartDateChange?: (date: string) => void;
  onEndDateChange?: (date: string) => void;
}) => {
  const formatStartDate = startDate ? new Date(startDate) : null;
  const formatEndDate = endDate ? new Date(endDate) : null;
  return (
    <BaseFormLabel label={label} sx={sx}>
      <Box display="flex" gap="10px" alignItems="center">
        <BaseDatePicker
          value={formatStartDate}
          onChange={(v) =>
            onStartDateChange(isValidDate(v) ? toIso8601DateTime(v) : "")
          }
        />
        <Typography justifyItems="Center">–</Typography>
        <BaseDatePicker
          value={formatEndDate}
          onChange={(v) =>
            onEndDateChange(isValidDate(v) ? toIso8601DateTime(v) : "")
          }
        />
      </Box>
    </BaseFormLabel>
  );
};
